<template>
  <div>
    <wc-page-title :title='$store.state.icons.modules.equipment.title'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            :title='currentDivision.division + " Equipment"'
            :showAdd='!currentDivision.is_all'
            @add='newEquipmentItem'
            showSearch
            v-model='search'
          >
            <template v-slot:toolbarButtons>
              <wc-show-archived-button v-model='showArchived' @toggleShowArchived='showArchived = !showArchived'></wc-show-archived-button>
            </template>
            <wc-division-tabs v-model='currentDivision'> 
              <v-data-table
                  dense
                  :headers='headers'
                  :items='filteredEquipment'
                  :search='search'
                  :loading='isLoading'
                  sort-by='number'
                  sort-desc
                  @click:row='openItem'
              >
                <template v-slot:item.name='{ item }'>
                  {{ item.name }}
                  <wc-archived v-if='item.archived'></wc-archived>
                </template>
                <template v-slot:item.division_obj.division='{ item }'>
                  <wc-division-nai :division_obj='item.division_obj'></wc-division-nai>
                </template>
                <template v-slot:item.notes='{ item }'>
                  <div class="text-truncate" style='max-width: 450px;'>{{ item.notes }}</div>
                  <!-- ellipsis don't show up properly here. using a workaround for now.  -->
                </template>
              </v-data-table>
            </wc-division-tabs>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
    <!-- add new dialog box below  -->
    <wc-dialog
      :showDialog='showDialog'
      :title='dialogTitle'
      :icon='currentDivision.icon'
      :iconColor='currentDivision.iconColor'
      @cancel='cancelEdit'
      @save='saveEdit'
      :loading='isLoading'
      :disableButtons='!isFormValid'
      lazy-validation
    >
      <v-form v-model="isFormValid" ref='form'>
        <v-select
          :items='divs'
          item-value='id'
          item-text='division'
          label='Division'
          v-model='newItem.division'
          @change='updateDivision'
        ></v-select>
        <v-text-field
          label='Name'
          ref='name'
          :rules='[v => !!v || "A name is required (this is the only required item)"]'
          v-model='newItem.name'
        ></v-text-field>
            <v-text-field
              label='Description'
              ref='description'
              v-model='newItem.description'
            ></v-text-field>
        <v-row>
          <v-col cols='12' md='4'>
            <v-text-field
              label='Serial Number'
              ref='serial_number'
              v-model='newItem.serial_number'
            ></v-text-field>
          </v-col>
          <v-col cols='12' md='4'>
            <v-text-field
              label='Model Number'
              ref='model_number'
              v-model='newItem.model_number'
            ></v-text-field>
          </v-col>
          <v-col cols='12' md='4'>
            <v-text-field
              label='Location'
              ref='location'
              v-model='newItem.location'
            ></v-text-field>
          </v-col>
        </v-row>
        <br>
        <span>Notes</span>
        <v-textarea outlined auto-grow v-model='newItem.notes'></v-textarea>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
  import assetsAPI from '@/modules/assets/api/equipment'
  import _ from 'lodash'
  import formRules from '@/mixins/formRules'

  export default {
    name: 'all-equipment',
    mixins: [formRules],
    data: () => ({
      currentDivision: {},
      resetItem: {
        name: "",
        description: '',
        serial_number: '',
        model_number: '',
        location: '',
        notes: "",
      },
      newItem: {},
      isLoading: true,
      showDialog: false,
      showArchived: false,
      isFormValid: true,
      search: "",
      equipment: [],
      headers: [
        { text: 'Name', value: 'name', width: '135' },
        // { text: 'Division', value: 'division_obj.division', align: 'center' },  // this is redundant due to tabs
        { text: 'Description', value: 'description' },
        { text: 'Serial Number', value: 'serial_number',width: '135' },
        { text: 'Model Number', value: 'model_number', width: '135' },
        { text: 'Location', value: 'location', width: '135' },
        { text: 'Notes', value: 'notes', }
      ]
    }),
    mounted () {
      this.getEquipment()
      this.itemReset()
      this.currentDivision = 'All' // eventually this can be set to a user defined value - use this.divs[n]
    },
    computed: {
      filteredEquipment () {
        if (!this.currentDivision.is_all) {
        return this.equipment.filter(inv => inv.division === this.currentDivision.id)
      }
        else { return this.equipment }
      },
      dialogTitle () {
        return "Add a new " + this.currentDivision.division + " equipment item"
      },
      divs () {
        return _.orderBy(this.$store.state.misc.divisions, 'order')
      },
    },
    methods: {
      updateDivision () {
        this.currentDivision = this.divs[_.findIndex(this.divs, ['id', this.newItem.division])]
      },
      async getEquipment () {
        this.isLoading = true
        this.equipment = await assetsAPI.getEquipment()
        this.isLoading = false
      },
      newEquipmentItem () {
        this.showDialog = true
        this.itemReset()
        this.newItem.division = this.currentDivision.id
        setTimeout(() => {
          this.$refs.form.resetValidation()
        }, 50)
        setTimeout(() => {
          this.$refs.name.focus()
        }, 100)
      },
      cancelEdit () {
        this.showDialog = false
      },
      openItem (item) {
        this.$router.push({ name: 'EquipmentDetailOverview', params: { id: item.id } })
      },
      async saveEdit () {
        this.isLoading = true
        this.equipment.push(await assetsAPI.newEquipmentItem(this.newItem))
        this.isLoading = false
        this.showDialog = false
      },
      itemReset() {
        this.newItem = _.cloneDeep(this.resetItem)
      }
    }
  }
</script>
